import { DEFAULT_COL_WIDTH, DEFAULT_ROW_HEIGHT, MIN_COL_WIDTH, MIN_ROW_HEIGHT } from "../constants";

export function toColumnLabel(index) {
  let value = index + 1;
  let label = "";
  while (value > 0) {
    const mod = (value - 1) % 26;
    label = String.fromCharCode(65 + mod) + label;
    value = Math.floor((value - 1) / 26);
  }
  return label;
}

export function getColumnWidthPx(colMeta) {
  if (!colMeta) return DEFAULT_COL_WIDTH;
  // wpx is already in screen pixels — use directly (SheetJS provides this for xlsx files)
  if (typeof colMeta.wpx === "number") return Math.max(MIN_COL_WIDTH, Math.round(colMeta.wpx));
  // wch is in Excel "character width" units. OOXML formula: chars × maxDigitWidth(7px) + 5px padding
  if (typeof colMeta.wch === "number") return Math.max(MIN_COL_WIDTH, Math.round(colMeta.wch * 7 + 5));
  return DEFAULT_COL_WIDTH;
}

export function getRowHeightPx(rowMeta) {
  if (!rowMeta) return DEFAULT_ROW_HEIGHT;
  // hpx is already in screen pixels
  if (typeof rowMeta.hpx === "number") return Math.max(MIN_ROW_HEIGHT, Math.round(rowMeta.hpx));
  // hpt is in points; 1pt = 96/72 px at 96 dpi
  if (typeof rowMeta.hpt === "number") return Math.max(MIN_ROW_HEIGHT, Math.round(rowMeta.hpt * (96 / 72)));
  return DEFAULT_ROW_HEIGHT;
}
